import { forwardRef } from 'react';
import { TextArea as RATextArea, TextAreaProps } from 'react-aria-components';
import { twMerge } from 'tailwind-merge';

export const Textarea = forwardRef<HTMLTextAreaElement, TextAreaProps>(
  ({ className, value, defaultValue, ...props }, ref) => {
    const normalizedProps: TextAreaProps = { ...props };

    if (value !== undefined) {
      normalizedProps.value = value ?? '';
    } else if (defaultValue !== undefined) {
      normalizedProps.defaultValue = defaultValue ?? '';
    }

    return (
      <RATextArea
        {...normalizedProps}
        className={(props) =>
          twMerge(
            'outline-lumeo-500 rounded-md border border-neutral-200 bg-white p-2 text-neutral-900 outline-0 transition invalid:border-red-500 focus:border-transparent focus-visible:outline-2 disabled:cursor-not-allowed disabled:bg-neutral-100 dark:border-neutral-700 dark:bg-neutral-900 dark:text-neutral-100 dark:disabled:bg-neutral-800',
            typeof className === 'function' ? className(props) : className
          )
        }
        ref={ref}
      />
    );
  }
);
